import { mapState, mapGetters, mapMutations} from 'vuex';

import VirtualBackground from '@/modules/virtualBackground';

export default {
  computed: {
    ...mapState('videoRtc', ['virtualBg', 'virtualBgModel']),
    ...mapGetters(['isAmazonChime']),
  },
  methods: {
    ...mapMutations('videoRtc', ['setVirtualBgModel']),

    async loadVBModel(isDeviceSettingPage = false) {
      // load model once
      if (this.virtualBgModel || (this.isAmazonChime && !isDeviceSettingPage)) {
        return true;
      }

      const virtualBgClass = new VirtualBackground();
      this.setVirtualBgModel(virtualBgClass);
      return await virtualBgClass.loadModel();
    }
  }
}
